import React from 'react';
import { createTheme } from '@mui/material/styles';
import { ThemeContext } from '../contexts/themeContext';

const useTheme = () => {
	const { currentTheme } = React.useContext(ThemeContext);

	const theme = createTheme({
		palette: {
			background: {
				default: currentTheme === 'light' ? '#F5F5F5' : '#000000',
			},
			mode: currentTheme,
			primary: {
				main: currentTheme === 'light' ? '#f17e22' : '#fafafa',
			},
			secondary: { main: '#f17e22' },
			buttons: {
				main: '#f17e22',
			},
			buttonsTextColors: {
				main: currentTheme === 'light' ? 'black' : 'white',
			},
			backGround: {
				main: currentTheme === 'light' ? '#fff' : '#424242',
			},
			bottomNavigator: {
				main: currentTheme === 'light' ? 'lightgray' : '#424242',
			},
			snackBarSuccess: '#3CB371',
			snackBarError: 'red',
			errorMsg: 'red',
		},
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					body: {
						textAlign: 'center',
					},
					'& input': {
						'&:-webkit-autofill': {
							transition:
								'background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s',
						},
						'&:-webkit-autofill:focus': {
							transition:
								'background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s',
						},
						'&:-webkit-autofill:hover': {
							transition:
								'background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s',
						},
					},
				},
			},
			MuiFilledInput: {
				styleOverrides: {
					input: {
						'&:-webkit-autofill': {
							WebkitBoxShadow: 'inherit',
							WebkitTextFillColor: 'inherit',
							caretColor: 'inherit',
						},
					},
				},
			},
			MuiOutlinedInput: {
				styleOverrides: {
					input: {
						'&:-webkit-autofill': {
							WebkitBoxShadow: 'inherit',
							WebkitTextFillColor: 'inherit',
							caretColor: 'inherit',
						},
					},
				},
			},
		},
	});

	return theme;
};

export default useTheme;
